module.exports = __webpack_public_path__ + "static/media/07-04.8a2dc1d6.png";